import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GrupoAcesso, GrupoAcessoService,} from '../../services/grupo-acesso/grupo-acesso.service';

@Component({
  selector: 'app-grupos',
  templateUrl: './grupos.component.html',
  styleUrls: ['./grupos.component.css'],
})
export class GruposComponent {

    grupoAcessoForm!: FormGroup;
    grupoAcesso: GrupoAcesso[] = [];
    currentGrupoAcessoId: number | null = null;

    constructor(
      private fb: FormBuilder,
      private grupoAcessoService: GrupoAcessoService
    ) {}


  ngOnInit(): void {

      this.grupoAcessoForm = this.fb.group({
        nome: ['', Validators.required],
        descricao:  ['', Validators.required],
        status: ['A', Validators.required],
      });
      this.loadCategorias();
    }

    // Carrega a lista de categorias
    loadCategorias(): void {
      this.grupoAcessoService.listarGrupoAcesso().subscribe({
        next: (data) => (this.grupoAcesso = data),
        error: (err) => console.error('Erro ao carregar grupos', err),
      });
    }


    salvarGrupoAcesso(): void {
      if (this.grupoAcessoForm.invalid) {
        return;
      }
      const formValue = this.grupoAcessoForm.value;
      const categoria: GrupoAcesso = {
        grupo_descricao: formValue.descricao,
        grupo_nome: formValue.nome,
        grupo_status: formValue.status,
      };


        this.grupoAcessoService.criarGrupoAcesso(categoria).subscribe({
          next: (data) => {
            this.resetForm();
            this.loadCategorias();
          },
          error: (err) => console.error('Erro ao criar grupos', err),
        });

    }

    resetForm(): void {

      this.currentGrupoAcessoId = null;
      this.grupoAcessoForm.reset({
        descricao: '',
        nome: '',
        status: 'A',
      });
    }



}
